import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import buildRoomCategoryDescriptionStatistic from './buildRoomCategoryDescriptionStatistic';

export default (tourProducts) => {
    const tourDescriptionsData = [];
    if (tourProducts?.length) {
        tourProducts.each((tourProduct) => {
            tourDescriptionsData.push(buildRoomCategoryDescriptionStatistic(tourProduct));
            const similarTours = tourProduct.get('similarTours');
            if (similarTours?.length) {
                similarTours.forEach((tourProductSimilar) => {
                    tourDescriptionsData.push(buildRoomCategoryDescriptionStatistic(tourProductSimilar));
                });
            }
        });

        trackingService.trackHotelPageRoomCategories(tourDescriptionsData);
    }
};